import { CircularProgress } from "@mui/material";
import { ReactNode, MouseEvent } from "react";

export type BtnType = 'primary' | 'secondary' | 'tertiary' | 'disabled' | 'warning';
export type BtnStyling = 'solid' | 'outline';

export interface Btn {
    id: string,
    type: BtnType,
    styling: BtnStyling,
    label: string,
    startingAdornment?: ReactNode,
    endingAdornment?: ReactNode,
    action?: (e: MouseEvent<HTMLButtonElement>) => void | Promise<void>,
    isLoading?: boolean,
}

export default function Buttons({
    id,
    type,
    styling,
    label,
    startingAdornment,
    endingAdornment,
    action,
    isLoading,
}: {
    id: string,
    type: BtnType,
    styling: BtnStyling,
    label: string,
    startingAdornment?: ReactNode,
    endingAdornment?: ReactNode,
    action?: (e: MouseEvent<HTMLButtonElement>) => void,
    isLoading?: boolean,
}) {
    

    if (type === 'primary') {
        return (
            <button id={id} onClick={action} className={`flex justify-between items-center gap-4 px-5 py-3 rounded-lg border border-primary hover:brightness-90 transition-all ${styling === 'solid' ? 'bg-primary text-white' : 'bg-white text-primary'}`}>
                <div className={`flex justify-start items-center gap-2`}>
                    {startingAdornment && <div className="w-[18px] h-[18px]">{startingAdornment}</div>}
                    <p className={`text-[14px] font-medium text-nowrap`}>{label}</p>
                </div>
                {endingAdornment && <div className="w-[18px] h-[18px]">{endingAdornment}</div>}
            </button>
        )
    } else if (type === 'secondary') {
        return (
            <button id={id} onClick={action} className={`flex justify-between items-center gap-4 px-5 py-3 rounded-lg border border-secondary hover:brightness-90 transition-all bg-secondary`}>
                <div className={`flex justify-start items-center gap-2 text-primary`}>
                    {startingAdornment && <div className="w-[18px] h-[18px]">{startingAdornment}</div>}
                    <p className={`text-[14px] font-medium text-nowrap`}>{label}</p>
                </div>
                {endingAdornment && <div className="w-[18px] h-[18px]">{endingAdornment}</div>}
            </button>
        )
    } else if (type === 'tertiary') {
        return (
            <button id={id} onClick={action} className={`flex justify-between items-center gap-4 px-5 py-3 rounded-lg border border-outline hover:border-primary bg-white text-default hover:text-primary transition-all`}>
                <div className={`flex justify-start items-center gap-2`}>
                    {startingAdornment && <div className="w-[18px] h-[18px]">{startingAdornment}</div>}
                    <p className={`text-[14px] font-medium text-nowrap`}>{label}</p>
                </div>
                {endingAdornment && <div className="w-[18px] h-[18px]">{endingAdornment}</div>}
            </button>
        )
    } else if (type === 'disabled') {
        return (
            <button id={id} disabled className={`flex justify-between items-center gap-4 px-5 py-3 rounded-lg border border-outline ${styling === 'solid' ? 'bg-outline' : 'bg-none'}`}>
                <div className={`flex justify-start items-center gap-2 ${styling === 'solid' ? 'text-white' : 'text-outline'}`}>
                    {startingAdornment && <div className="w-[18px] h-[18px]">{startingAdornment}</div>}
                    {isLoading !== undefined && isLoading && (
                        <CircularProgress size={16} color="inherit"/>
                    )}
                    <p className={`text-[14px] font-medium text-nowrap`}>{label}</p>
                </div>
                {endingAdornment && <div className="w-[18px] h-[18px]">{endingAdornment}</div>}
            </button>
        )
    } else if (type === 'warning') {
        return (
            <button id={id} onClick={action} className={`flex justify-between items-center gap-4 px-5 py-3 rounded-lg border border-warning hover:brightness-90 transition-all bg-warning`}>
                <div className={`flex justify-start items-center gap-2 text-white`}>
                    {startingAdornment && <div className="w-[18px] h-[18px]">{startingAdornment}</div>}
                    <p className={`text-[14px] font-medium text-nowrap`}>{label}</p>
                </div>
                {endingAdornment && <div className="w-[18px] h-[18px]">{endingAdornment}</div>}
            </button>
        )
    } else {
        return (
            <button id={id} onClick={action} className={`flex justify-between items-center gap-4 px-5 py-3 rounded-lg border border-[#006D77] hover:brightness-90 transition-all ${styling === 'solid' ? 'bg-[#006D77]' : 'bg-white'}`}>
                <div className={`flex justify-start items-center gap-2 ${styling === 'solid' ? 'text-white' : 'text-[#006D77]'}`}>
                    {startingAdornment && <div className="w-[18px] h-[18px]">{startingAdornment}</div>}
                    <p className={`text-[14px] font-medium text-nowrap`}>{label}</p>
                </div>
                {endingAdornment && <div className="w-[18px] h-[18px]">{endingAdornment}</div>}
            </button>
        )
    }
}